import * as React from "react";

const SvgShieldexclamation = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={color}
      strokeWidth={2}
    >
      <path d="M20.618 6.095A11.835 11.835 0 0 1 12 3a11.835 11.835 0 0 1-8.618 3.095A12.45 12.45 0 0 0 3 9.166C3 14.86 6.824 19.644 12 21c5.176-1.356 9-6.14 9-11.834 0-1.06-.133-2.09-.382-3.07ZM12.5 10v4" />
    </g>
  </svg>
);

export default SvgShieldexclamation;
